import postAPI from './postAPI.js'

export default async function postAddField(fieldData) {
    const data = await postAPI('admin/taskflows/steps/fields/add', fieldData);
    return data;
}
